<template>
  <main :class="style.doctorAppointment">
    <h2>
      Мы получили вашу заявку, администратор свяжется с вами в ближайшее время
    </h2>
    <div
      v-if="'specialization' in chose?.doctor"
      :class="style.infoAppointment"
    >
      <section v-if="chose?.doctor?.specialization">
        <span
          v-text="
            chose.doctor.specialization[0]
              ? chose.doctor.specialization.join(', ')
              : 'Специализация врача'
          "
        />
        <div v-text="chose.DoctorName" />
      </section>
      <section v-if="chose?.doctor?.address">
        <span>Адрес</span>
        <div
          v-show="bool"
          v-for="(bool, address) in chose.doctor?.address"
          v-text="address"
        />
      </section>
      <section v-if="chose.DoctorService">
        <span>Услуга</span>
        <div v-text="chose.DoctorService" />
      </section>
      <section v-if="chose.ClientFullName">
        <span>ФИО</span>
        <div v-text="chose.ClientFullName" />
      </section>
      <section>
        <span>телефон</span>
        <div v-text="chose.ClientPhone" />
      </section>
      <section v-if="chose.comment">
        <span>Комментарий</span>
        <div v-text="chose.comment" />
      </section>
    </div>
  </main>
</template>
<script lang="ts">
import style from "../StyleWidget.module.scss";
import {defineComponent} from "vue";
import {chose} from "../WidgetTypes";
export default defineComponent({
  name: "ConsultationSuccess",
  data() {
    return {
      style
    };
  },
  computed: {
    chose(): chose {
      return this.$widgetStore.getChose;
    }
  }
});
</script>
